import React, { useState, useCallback, useEffect, useMemo } from 'react'
import FilterComponentParams from './types/FilterComponentParams'
import { InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import debounce from 'lodash.debounce'

function PatternNameSearchFilter(props: FilterComponentParams) {
  const { backtestFilters, setBacktestFilters } = props

  const [inputValue, setInputValue] = useState(backtestFilters.patternNameSearch || '')

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    debounceUpdateBacktestFilters(event.target.value)
  }

  const updateBacktestFilters = useCallback(
    (value: string) => {
      setBacktestFilters((prev: any) => ({
        ...prev,
        patternNameSearch: value,
      }))
    },
    [setBacktestFilters]
  )

  const debounceUpdateBacktestFilters = useMemo(
    () => debounce(updateBacktestFilters, 600),
    [updateBacktestFilters]
  )

  useEffect(() => {
    setInputValue(backtestFilters.patternNameSearch || '')
  }, [backtestFilters.patternNameSearch])

  return (
    <Box flexBasis={300} flexShrink={1}>
      <TextField
        fullWidth
        size="small"
        value={inputValue}
        onChange={handleSearchChange}
        placeholder="Search backtests..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ opacity: 0.5 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.custom3',
            borderRadius: '8px',
            '& fieldset': {
              borderColor: 'transparent',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.1)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
              borderWidth: '1px',
            },
          },
        }}
      />
    </Box>
  )
}

export default PatternNameSearchFilter
